import { render, staticRenderFns } from "./ArticleExam.vue?vue&type=template&id=3e5a1a44&"
import script from "./ArticleExam.vue?vue&type=script&lang=js&"
export * from "./ArticleExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports